(function () {
  document.addEventListener(
    "click",
    (e) => {
      const trigger = e.target.closest?.(".image-with-text-read-more__trigger");
      if (!trigger) return;
      const modalId = trigger.getAttribute("data-modal-target");
      if (!modalId) return;
      const modal = document.getElementById(modalId);
      if (!modal || typeof modal.show !== "function") return;
      e.preventDefault();
      e.stopPropagation();
      modal.show(trigger);
    },
    true
  );
})();
